import { CommonHttpHelper, NO_DATA_MESSAGE, BASIC_INITIAL_STATE } from '../../utils/HttpHelper';

const getOrgGroupsByOrgUnit = (orgUnitId, state, setState) => {
  if (orgUnitId && state.isArrayLoading !== true && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      orgUnitId,
      message: 'Loading...'
    };
    setState(newState);

    const orgUnitIdForUrl = encodeURIComponent(orgUnitId);
    const url = `/OrgGroup/orgUnit/flat/${orgUnitIdForUrl}`;
    CommonHttpHelper(url, 'GET')
      .then((data) => {
        if (!data) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          const items = data.map((x) => { return { id: x.orgGroupId, name: x.groupName }; });

          newState = {
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            data,
            items,
            message: ''
          };
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  orgUnitId: ''
};

const OrgGroupsByOrgUnitData = {
  INITIAL_STATE,
  getOrgGroupsByOrgUnit
};

export default OrgGroupsByOrgUnitData;
